// src/components/modals/EscrowWithdrawalModal.jsx
import React, { useState } from 'react';

const EscrowWithdrawalModal = ({ show, onHide, availableBalance, currency }) => {
  const [amount, setAmount] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  
  const formatCurrency = (amt) => {
    if (!amt) return currency === 'NGN' ? '₦0.00' : '$0.00';
    return new Intl.NumberFormat(currency === 'NGN' ? 'en-NG' : 'en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amt);
  };

  const handleWithdraw = async () => {
    // Implement withdrawal logic
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold">Withdraw Funds</h2>
          <button onClick={onHide} className="text-gray-400 hover:text-gray-600">
            &times;
          </button>
        </div>
        
        <div className="p-6">
          {/* Withdrawal form implementation */}
        </div>
      </div>
    </div>
  );
};

export default EscrowWithdrawalModal;